module.exports = __webpack_public_path__ + "img/goggles.1f7eec79.png";